import { mutator } from 'satcheljs';
import { addToAgendaMailDisabledMap } from '../actions/internalActions';
import getStore from 'owa-agenda-mail-option/lib/store/store';

export const addToAgendaMailDisabledMapMutator = mutator(
    addToAgendaMailDisabledMap,
    actionMessage => {
        const { folderId, agendaMailDisabledToUpdate } = actionMessage;

        // Add the folderId to the update map
        getStore().agendaMailDisabledMap.set(folderId, agendaMailDisabledToUpdate);
    }
);
